module.exports = __webpack_public_path__ + "img/D-email-icon.19fd6b95.svg";